module.exports = __webpack_public_path__ + "./workspace-pic03_661ce91bedc0cd9034f3811496c1e5f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionWork/workspace-pic03.jpg
// module id = 636
// module chunks = 0